import { heroBannerSlideshowProjection } from './pageBuilderProjection';

export const PAGE_HEROBANNER_QUERY = `
  *[_type == $pageType && slug.current == $slug][0] {
    heroBanner{
      ${heroBannerSlideshowProjection}
    },
  }
`;

export const PRODUCTS_LIST_HEROBANNER_QUERY = `
  *[
    _type == $pageType &&
    subcategory->slug.current == $slug &&
    subcategory->parentCategory->slug.current == $parentSlug
  ][0] {
    heroBanner{
      ${heroBannerSlideshowProjection}
    },
  }
`;

export const ARTICLES_LIST_HEROBANNER_QUERY = `
  *[_type == $pageType && type == $slug][0] {
    heroBanner{
      ${heroBannerSlideshowProjection}
    },
  }
`;
